import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { Club, emptyClub } from "../../../../interfaces/club";
import { deleteClub, getClubSingle } from "../../../../services/club";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface AdminClubDeleteProps {
    id: number;
    onDelete: CallableFunction;
    onClose: CallableFunction;
}

export function AdminClubDelete(props: AdminClubDeleteProps) {
    const [club, setClub] = useState<Club>(emptyClub);

    const handleDelete = () => {
        deleteClub(props.id)
            .then(response => {
                if (response.data == 0) {
                    alert(t("Club cannot be deleted. There is related data for the club."));
                    props.onClose();
                } else {
                    props.onDelete(props.id);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    useEffect(() => {
        getClubSingle(props.id)
            .then(response => {
                setClub(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <Modal className="admin-club-delete-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("delete_club") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { club.id == 0 && 
                    <LoadingSpinner />
                }
                { club.id != 0 &&
                    <Form onSubmit={ handleDelete }>
                        <div className="fields">
                            <Trans i18nKey="delete_club_message"
                                values={{
                                    club_name: club.name
                                   }} />
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Delete") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}
